export const environment = {
  production: true,
  API_BASE_URL: "https://api.licthailand.com",
  authTokenKey: "token",
  authorizationCode: "Lic008Thai"
};
